import { render } from "./PackageStatusCard.vue?vue&type=template&id=78e55a03&scoped=true"
import script from "./PackageStatusCard.vue?vue&type=script&lang=js"
export * from "./PackageStatusCard.vue?vue&type=script&lang=js"

import "./PackageStatusCard.vue?vue&type=style&index=0&id=78e55a03&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e55a03"]])

export default __exports__